import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthEvent, AuthService, IdentityClaims } from '@michelin/auth';
import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AppService } from '../app.service';
import { UserData } from '../interfaces/user';

export const THOUSAND = 1000;

@Injectable({
  providedIn: 'root'
})
export class AuthenticationWrapperService {
  private readonly authService = inject(AuthService);
  private readonly userService = inject(AppService);

  onLoginRequired$ = new Subject<void>();
  onLoginSuccess$ = new Subject<UserData>();
  onLogoutSuccess$ = new Subject<void>();
  onSessionExpired$ = new Subject<void>();
  claims: Partial<IdentityClaims>;
  /**
   * Constructor
   *
   * @param authService authService
   * @param userService appService
   */
  constructor() {
    this.authService.events
      .pipe(
        filter((e: AuthEvent) => {
          return e.type === 'token_received';
        })
      )
      .subscribe(() => {
        this.claims = this.authService.getIdentityClaims();
        this.userService.getUsersById(this.claims.uid).subscribe(
          (user: UserData) => {
            //only fetch user at frist received token and not for all refreshed
            if (sessionStorage.getItem('logged') !== 'true') {
              sessionStorage.setItem('logged', 'true');
              localStorage.setItem('user', JSON.stringify(user)); // add the information of the user in the localStorage
              this.onLoginSuccess$.next(this.getUser());
            }
          },
          () => {}
        );
      });
  }

  /**
   * Logout
   */
  public logout(router: Router): void {
    sessionStorage.setItem('logoutRedirectTo', router.url + 'login');
    sessionStorage.removeItem('logged');
    sessionStorage.removeItem('loggedHBI');
    this.authService.logOut();
  }

  /**
   * Get the user token
   */
  public getToken(): string {
    return this.authService.getAccessToken();
  }

  /**
   * Get the current user FROM BACKEND
   */
  public getUser(): UserData {
    if (this.authService.hasValidIdToken() === null) {
      return {
        id: null,
        idMichelin: null,
        firstName: null,
        lastName: null,
        email: null,
        name: null,
        role: null,
        applications: null,
        status: null,
        lastConnection: null
      };
    } else {
      this.userService.getUsersById(this.claims.uid).subscribe((user) => {
        return user;
      });
    }
  }

  /**
   * If the user is authenticated
   */
  public isAuthenticated(): boolean {
    return this.authService.hasValidAccessToken();
  }
}
